import Link from 'next/link'
import styles from './styles.module.scss'
import InlineSVG from "@/components/InlineSVG";
import { urlFor } from '../../sanity/lib/image';

export function Tags({ tags, wrapperStyles }) {
	return (
		<div className={wrapperStyles}>
			{tags && tags.map((tag) => {
				let styleObject = {
					"--text-color": tag.textColor ? `rgba(${tag.textColor.rgb.r},${tag.textColor.rgb.g},${tag.textColor.rgb.b},${tag.textColor.rgb.a})` : ""
				}
				return (tag.href
					? <Link style={styleObject} href={tag.href} key={tag._key} className={styles.tag}>{tag.icon && <InlineSVG url={urlFor(tag.icon).url()} />}{tag.text}</Link>
					: <div style={styleObject} key={tag._key} className={styles.tag}>{tag.icon && <InlineSVG url={urlFor(tag.icon).url()} />}{tag.text}</div>)
			})}
		</div>
	)
}